import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import ReclamationPageHeader from './ReclamationPageHeader';

import { openSetDateVerificationDialog } from 'store/common/commonActions';

class ReclamationPageHeaderContainer extends React.Component {

    handleClickSetVerificationDate = () => {
        // On change le state de l'appli
        this.props.openSetDateVerificationDialog(this.props.reclamation.id, this.props.reclamation.dateVerification);
    };

    render() {
        const { templateReclamationPage } = this.props;

        let _templateReclamationPage = false;
        if (templateReclamationPage !== undefined) {
            _templateReclamationPage = templateReclamationPage;
        }

        return (
            <ReclamationPageHeader
                reclamation={this.props.reclamation}
                onClickSetVerificationDate={this.handleClickSetVerificationDate}
                afficheVerification={this.props.afficheVerification}
                templateReclamationPage={_templateReclamationPage}
            />
        );
    }
}

ReclamationPageHeader.propTypes = {
    reclamation: PropTypes.object.isRequired,
    afficheVerification: PropTypes.bool,
    templateReclamationPage: PropTypes.bool 
};

const mapDispatchToProps = dispatch => ({
    openSetDateVerificationDialog: (reclamationId, date) => dispatch(openSetDateVerificationDialog(reclamationId, date))
});

export default connect(null, mapDispatchToProps)(ReclamationPageHeaderContainer);